import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AbstractOnboardingPageComponent } from 'src/app/core/abstracts/components/onboarding-page.abstract';
import { IPageContent } from 'src/app/core/interfaces/common/content/page-content.interface';
import { ITransition } from 'src/app/core/interfaces/onboarding/page-state/transition.interface';
import { FinancialProfileService } from 'src/app/core/services/onboarding/finacial-profile.service';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import { IFinancialProfileStore } from 'src/app/core/store/onboarding/interfaces/financial-profile-store.interface';
import { selectAllFinancialProfile } from 'src/app/core/store/onboarding/reducers+selectors/financial-profile.selector';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent
  extends AbstractOnboardingPageComponent
  implements OnInit, OnDestroy
{
  displayData: { key: string; value: string }[] = [];
  subscriptions: Subscription[] = [];
  headerText = 'Financial Profile Summary';

  constructor(
    private route: ActivatedRoute,
    private fps: FinancialProfileService,
    private store: Store<IAppState>
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.subscriptions.push(
      this.route.data.subscribe(async (data) => {
        const { transitions } = data['data'];
        const { contentDict } = data['data'];
        this.populatePageStates(transitions);
        this.populatePageContent(contentDict);
        const props$ = this.store.select(selectAllFinancialProfile);
        const sub = props$.subscribe(async (props) => {
          await this.buildDisplayPayload(props);
        });
        sub.unsubscribe();
      })
    );
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async buildDisplayPayload(fpStore: IFinancialProfileStore) {
    const invoiceAmount = fpStore.invoiceAmount.value;
    const invoiceTerm = fpStore.invoiceTerm.value;

    this.displayData = [
      {
        key: 'Monthly Invoice Amount',
        value: invoiceAmount,
      },
      {
        key: 'Typical Invoice Term',
        value: invoiceTerm,
      },
    ];
  }

  populatePageStates(transitions: ITransition[]): void {}
  populatePageContent(contentDict: Map<number, IPageContent>): void {}
}
